import { NumberInput } from "@/lib/Components/Form/Inputs/NumberInput";
import { TimezoneInput } from "@/lib/Components/Form/Inputs/TimezoneInput";
import { OpenHoursInput } from "@/app/Offices/Components/OpenHoursInput";
import { LogisticsOpenHoursInfoBanner } from "@/app/Suppliers/Components/LogisticsOpenHoursInfoBanner";

export function SupplierConfirmationTimeframeForm() {
  return (
    <>
      <NumberInput
        name="hours_to_confirm"
        label="Hours notice"
        inputProps={{
          min: 0,
        }}
      />
      <TimezoneInput name={"timezone"} label={"Timezone"} />

      <LogisticsOpenHoursInfoBanner />

      <OpenHoursInput prefix={"logistics_hours"} label="Logistics Hours" />
    </>
  );
}
